import {charcoal} from '../sass/base/_exports.sass';

export const DeleteBinLineIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.6667 7.99999H29.3333V10.6667H26.6667V28C26.6667 28.3536 26.5262 28.6927 26.2761 28.9428C26.0261 29.1928 25.687 29.3333 25.3333 29.3333H6.66666C6.31304 29.3333 5.9739 29.1928 5.72386 28.9428C5.47381 28.6927 5.33333 28.3536 5.33333 28V10.6667H2.66666V7.99999H9.33333V3.99999C9.33333 3.64637 9.47381 3.30723 9.72386 3.05718C9.9739 2.80713 10.313 2.66666 10.6667 2.66666H21.3333C21.687 2.66666 22.0261 2.80713 22.2761 3.05718C22.5262 3.30723 22.6667 3.64637 22.6667 3.99999V7.99999ZM24 10.6667H8V26.6667H24V10.6667ZM12 5.33332V7.99999H20V5.33332H12Z"
        fill={color}
      />
    </svg>
  );
};
